"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author PKr
 */


var WindowItemSimulationUpdateDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowItemSimulationUpdateDTO, _DomainObject_1$Domai);

  function WindowItemSimulationUpdateDTO(windowItemId, regularPrice, regularPriceNote, promoPrice, promoPriceNote, promoVolume, promoVolumeNote, posMarginImpactTheoretical, posMarginImpactTheoreticalNote, posMechanics, posMechanicsNote, promoPurchasePrice, promoPurchasePriceNote, unitBackDiscount, unitBackDiscountNote, vaValue, vaValueNote) {
    var _this;

    _classCallCheck(this, WindowItemSimulationUpdateDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowItemSimulationUpdateDTO).call(this));
    _this.windowItemId = windowItemId;
    _this.regularPrice = regularPrice;
    _this.regularPriceNote = regularPriceNote;
    _this.promoPrice = promoPrice;
    _this.promoPriceNote = promoPriceNote;
    _this.promoVolume = promoVolume;
    _this.promoVolumeNote = promoVolumeNote;
    _this.posMarginImpactTheoretical = posMarginImpactTheoretical;
    _this.posMarginImpactTheoreticalNote = posMarginImpactTheoreticalNote;
    _this.posMechanics = posMechanics;
    _this.posMechanicsNote = posMechanicsNote;
    _this.promoPurchasePrice = promoPurchasePrice;
    _this.promoPurchasePriceNote = promoPurchasePriceNote;
    _this.unitBackDiscount = unitBackDiscount;
    _this.unitBackDiscountNote = unitBackDiscountNote;
    _this.vaValue = vaValue;
    _this.vaValueNote = vaValueNote;
    return _this;
  }

  return WindowItemSimulationUpdateDTO;
}(DomainObject_1.DomainObject);

exports.WindowItemSimulationUpdateDTO = WindowItemSimulationUpdateDTO;